import React from 'react';
import { useNotifications, Notification, NotificationType } from '../contexts/NotificationContext';
import './NotificationToast.scss';

interface NotificationToastProps {
  notification: Notification;
}

const NotificationToast: React.FC<NotificationToastProps> = ({ notification }) => {
  const { removeNotification } = useNotifications();

  const getIcon = (type: NotificationType) => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '📢';
    }
  };

  const getTypeClass = (type: NotificationType) => {
    return `notification-toast--${type}`;
  };

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className={`notification-toast ${getTypeClass(notification.type)}`}>
      <div className="notification-toast__header">
        <div className="notification-toast__icon">
          {getIcon(notification.type)}
        </div>
        <div className="notification-toast__title">
          {notification.title}
        </div>
        <button
          className="notification-toast__close"
          onClick={() => removeNotification(notification.id)}
          aria-label="Fechar notificação"
        >
          ×
        </button>
      </div>
      
      {notification.message && (
        <div className="notification-toast__message">
          {notification.message}
        </div>
      )}
      
      <div className="notification-toast__time">
        {formatTime(notification.createdAt)}
      </div>
      
      {notification.duration !== 0 && (
        <div className="notification-toast__progress">
          <div 
            className="notification-toast__progress-bar"
            style={{
              animationDuration: `${notification.duration || 5000}ms`,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default NotificationToast; 